export const PATHS = {
  FORGOT_PASSWORD: '/forgot-password',
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
  SIGN_UP: '/sign-up',
  SIGN_UP_QR: '/sign-up/qr/:id',
  EMAIL_VALIDATION: '/email-validation',
  LOGOUT: '/logout',
}
